import {
  // AppstoreOutlined,
  FileTextFilled,
  FileDoneOutlined,
  FileProtectOutlined,
  HddOutlined,
  // InboxOutlined,
  TeamOutlined,
  DropboxOutlined ,
  ExperimentOutlined,
  ReconciliationFilled,
  // CodeSandboxOutlined,
} from "@ant-design/icons";
import { BsBoxes,BsBoxArrowInDown  } from "react-icons/bs";

import { TbReportMoney } from "react-icons/tb";
import { FaBottleDroplet, FaBoxesPacking,FaCubesStacked  } from "react-icons/fa6";
import { RiTeamFill } from "react-icons/ri";
import { MdOutlineDashboard  } from "react-icons/md";
import { FaTruckLoading,FaTag,FaFileInvoiceDollar,FaRegFileAlt  } from "react-icons/fa";
// import { IoLogoModelS } from "react-icons/io";
import { GiMetalBar,GiMaterialsScience,GiChemicalDrop  } from "react-icons/gi";

import { BiPackage } from "react-icons/bi";
import { AiOutlineApartment } from "react-icons/ai";

import {
  MdOutlineGroup,
  MdRequestQuote,
  MdInventory,
} from "react-icons/md";

/* ── สิทธิเข้าถึงเมนูตาม role (md, admin, sale, planner, qc, rd) ── */
let everyone_auth   = ['md','admin','sale','planner','qc','rd'];
let erp_system_auth = ['md','admin','sale','planner','qc'];          // RD: n
let invoice_auth    = ['md','admin','sale'];                          // Planner/QC/RD: n
let erp_master_auth = ['md','admin','sale','planner','qc','rd'];             // Sale: n
let customer_auth   = ['md','admin','sale','planner'];                // QC/RD: n
let supplier_auth   = ['md','admin','planner','qc','rd'];             // Sale: n
let runcode_auth    = ['md','admin','planner'];                       // Sale/QC/RD: n
let rd_system_auth  = ['md','admin','sale','qc','rd'];                // Planner: n
let rd_master_auth  = ['md','admin','sale','rd'];                     // Planner/QC: n
let admin_auth      = ['md'];                                         // MD เท่านั้น

let _nav = [
  {
    title: "Home",
    type: "group",
  },
  {
    title: "Dashboard",
    icon: <MdOutlineDashboard className="nav-ico" />,
    to: "/dashboard",
  },
  {
    title: "ERP Report",
    type: "group",
    role: everyone_auth,
  },
  {
    title: "รายงานคำนวนวัถตุดิบ",
    icon: <GiMaterialsScience className="nav-ico" />,
    to: "/ERP/calculate-material",
    role: everyone_auth,
  },
  {
    title: "รายงานการใช้ส่วนผสม",
    icon: <GiChemicalDrop className="nav-ico" />,
    to: "/ERP/material-usage",
    role: everyone_auth,
  },
  {
    title: "รายงานประวัติการขาย",
    icon: <TbReportMoney className="nav-ico" />,
    to: "/ERP/sales-history",
    role: everyone_auth,
  },
  {
    title: "เช็คสต๊อกรวม",
    icon: <MdInventory className="nav-ico" />,
    to: "/ERP/stock-summary",
    role: everyone_auth,
  },
  {
    title: "รายงาน PO ค้างรับ",
    icon: <TbReportMoney className="nav-ico" />,
    to: "/ERP/po-pending",
    role: everyone_auth,
  },
  {
    title: "ขนาด + น้ำหนักสินค้า",
    icon: <TbReportMoney className="nav-ico" />,
    to: "/ERP/size-weight",
    role: invoice_auth,
  },
  {
    title: "ERP System",
    type: "group",
    role: everyone_auth,
  },

  {
    title: "Job Order",
    icon: <FileDoneOutlined className="nav-ico" />,
    to: "/ERP/job-order",
    role: everyone_auth,
  },
  {
    title: "Production Order",
    icon: <HddOutlined className="nav-ico" />,
    to: "/ERP/product-order",
    role: erp_system_auth,
  },
  {
    title: "ใบเบิกวัตถุดิบ",
    icon: <FaRegFileAlt className="nav-ico" />,
    to: "/ERP/requisition",
    role: erp_system_auth,
  },
  {
    title: "ส่งมอบ FG",
    icon: <BsBoxArrowInDown className="nav-ico" />,
    to: "/ERP/fg-handover",
    role: erp_system_auth,
  },
  {
    title: "Purchase Order",
    icon: <FaFileInvoiceDollar  className="nav-ico" />,
    to: "/ERP/purchase-order",
    role: erp_system_auth,
  },
  {
    title: "Goods Receipt",
    icon: <BsBoxArrowInDown  className="nav-ico" />,
    to: "/ERP/goods-receipt",
    role: erp_system_auth,
  },
  {
    title: "JU รับเข้าสต๊อก",
    icon: <BsBoxArrowInDown className="nav-ico" />,
    to: "/ERP/ju",
    role: erp_system_auth,
  },
  {
    title: "Delivery Note",
    icon: <FaTruckLoading className="nav-ico" />,
    to: "/ERP/delivery-note",
    role: erp_system_auth,
  },
  {
    title: "Packing List",
    icon: <FaRegFileAlt className="nav-ico" />,
    to: "/ERP/packing-list",
    role: erp_system_auth,
  },
  // {
  //   title: "Proforma Invoice",
  //   icon: <FaRegFileAlt className="nav-ico" />,
  //   to: "/ERP/proforma",
  //   role: invoice_auth,
  // },
  {
    title: "Invoice",
    icon: <FaFileInvoiceDollar className="nav-ico" />,
    to: "/ERP/invoice",
    role: invoice_auth,
  },
  {
    title: "แผนโหลด / จองเรือ",
    icon: <FaTruckLoading className="nav-ico" />,
    to: "/ERP/shipment-plan",
    role: erp_system_auth,
  },
  {
    title: "ERP Master",
    type: "group",
    role: everyone_auth,
  },
  {
    title: "BOM",
    icon: <AiOutlineApartment className="nav-ico" />,
    to: "/ERP/bom",
    role: erp_master_auth,
  },
  {
    title: "Master Process",
    icon: <FaCubesStacked className="nav-ico" />,
    to: "/ERP/master-process",
    role: erp_master_auth,
  },
  {
    title: "Raw Material",
    icon: <GiMetalBar className="nav-ico" />,
    to: "/ERP/raw-material",
    role: erp_master_auth,
  },
  {
    title: "Indirect Material",
    icon: <GiMetalBar className="nav-ico" />,
    to: "/ERP/indirect-material",
    role: erp_master_auth,
  },
  {
    title: "Ingredients",
    icon: <FaBoxesPacking className="nav-ico" />,
    to: "/ERP/ingredients",
    role: erp_master_auth,
  },
  {
    title: "Packing Goods",
    icon: <BiPackage className="nav-ico" />,
    to: "/ERP/packing-goods",
    role: everyone_auth,
  },
  {
    title: "Finished Goods",
    icon: <BsBoxes className="nav-ico" />,
    to: "/ERP/finished-goods",
    role: everyone_auth,
  },
  {
    title: "WI",
    icon: <FaCubesStacked   className="nav-ico" />,
    to: "/ERP/wi",
    role: erp_master_auth,
  },
  {
    title: "Packaging",
    icon: <FaBottleDroplet className="nav-ico" />,
    to: "/ERP/packaging",
    role: erp_master_auth,
  },
  {
    title: "Packing",
    icon: <DropboxOutlined  className="nav-ico" />,
    to: "/ERP/packing-master",
    role: erp_master_auth,
  },
  {
    title: "Customer",
    icon: <RiTeamFill className="nav-ico" />,
    to: "/ERP/customer",
    role: customer_auth,
  },
  {
    title: "Supplier",
    icon: <MdOutlineGroup className="nav-ico" />,
    to: "/ERP/supplier",
    role: supplier_auth,
  },
  {
    title: "Runcode",
    icon: <FaTag className="nav-ico" />,
    to: "/ERP/runcode",
    role: runcode_auth,
  },
  {
    title: "อัตราแลกเปลี่ยน",
    icon: <FaFileInvoiceDollar className="nav-ico" />,
    to: "/ERP/fx-rate",
    role: erp_master_auth,
  },
  {
    title: "RD System",
    type: "group",
    role: rd_system_auth,
  },
  {
    title: "Sample Request",
    icon: <FileTextFilled className="nav-ico" />,
    to: "/sample-request",
    role: rd_system_auth,
  },
  {
    title: "Sample Preparation",
    icon: <ReconciliationFilled className="nav-ico" />,
    to: "/sample-preparation",
    role: rd_system_auth,
  },
  {
    title: "Product Specification",
    icon: <FaRegFileAlt className="nav-ico" />,
    to: "/product-specification",
    role: rd_system_auth,
  },
  {
    title: "Pilot Scale",
    icon: <ExperimentOutlined className="nav-ico" />,
    to: "/pilot-scale",
    role: rd_system_auth,
  },
  {
    title: "Delivery Note",
    icon: <FileProtectOutlined  className="nav-ico"/>,
    to: "/delivery-note",
    role: rd_system_auth,
  },
  {
    title: "Estmate Cost",
    icon: <TbReportMoney  className="nav-ico"/>,
    to: "/estimation",
    role: rd_system_auth,
  },
  {
    title: "Packing Set",
    icon: <FaBoxesPacking  className="nav-ico"/>,
    to: "/packing-set",
    role: rd_system_auth,
  },
  {
    title: "Quotation",
    icon: <MdRequestQuote  className="nav-ico"/>,
    to: "/quotation",
    role: rd_system_auth,
  },



  {
    title: "RD Master",
    type: "group",
    role: rd_master_auth,
  },
  {
    title: "Items",
    icon: <FileDoneOutlined className="nav-ico" />,
    to: "/items",
    role: rd_master_auth,
  },
  {
    title: "RD Packaging",
    icon: <FaBottleDroplet className="nav-ico" />,
    to: "/packaging",
    role: rd_master_auth,
  },
  {
    title: "Shipping Type",
    icon: <FaTruckLoading className="nav-ico" />,
    to: "/shipping-type",
    role: rd_master_auth,
  },

  {
    title: "RD Unit",
    icon: <HddOutlined className="nav-ico" />,
    to: "/unit",
    role: rd_master_auth,
  },
  {
    title: "RD Customers",
    icon: <RiTeamFill className="nav-ico" />,
    to: "/customers",
    role: rd_master_auth,
  },
  {
    title: "RD Suppliers",
    icon: <MdOutlineGroup className="nav-ico" />,
    to: "/suppliers",
    role: rd_master_auth,
  },
  {
    title: "Admin",
    type: "group",
    role: admin_auth,
  },
  {
    title: "User",
    icon: <TeamOutlined className="nav-ico" />,
    to: "/user",
    role: admin_auth,
  },
  {
    title: "สิทธิ์การเข้าถึง",
    icon: <FaTag className="nav-ico" />,
    to: "/permission",
    role: admin_auth,
  },
];

export default _nav;
